import React from "react"
import {
  createStyles,
  forwardRef,
  HTMLStyledProps,
  StyleProps,
} from "@design-system/styled-system"
import { Box } from "./Box"

export interface FlexOptions {
  /**
   * Shorthand for `alignItems` style prop
   * @type StyleProps["alignItems"]
   */
  align?: StyleProps["alignItems"]

  /**
   * Shorthand for `justifyContent` style prop
   * @type StyleProps["justifyContent"]
   */
  justify?: StyleProps["justifyContent"]

  /**
   * Shorthand for `flexWrap` style prop
   * @type StyleProps["flexWrap"]
   */
  wrap?: StyleProps["flexWrap"]

  /**
   * Shorthand for `flexDirection` style prop
   * @type StyleProps["flexDirection"]
   */
  direction?: StyleProps["flexDirection"]

  /**
   * Shorthand for `flexBasis` style prop
   * @type StyleProps["flexBasis"]
   */
  basis?: StyleProps["flexBasis"]

  /**
   * Shorthand for `flexGrow` style prop
   * @type StyleProps["flexGrow"]
   */
  grow?: StyleProps["flexGrow"]

  /**
   * Shorthand for `flexShrink` style prop
   * @type StyleProps["flexShrink"]
   */
  shrink?: StyleProps["flexShrink"]
}

export interface FlexProps
  extends Omit<HTMLStyledProps<"div">, "direction">,
    FlexOptions {}

export const Flex = forwardRef<FlexProps, "div">((props, ref) => {
  const {
    direction,
    align,
    justify,
    wrap,
    basis,
    grow,
    shrink,
    style,
    ...rest
  } = props

  return (
    <Box
      {...rest}
      flexDirection={direction}
      alignItems={align}
      justifyContent={justify}
      flexWrap={wrap}
      flexBasis={basis}
      flexGrow={grow}
      flexShrink={shrink}
      ref={ref}
      style={[styles.root, style]}
    />
  )
})
Flex.displayName = "Flex"

const styles = createStyles({
  root: {
    display: "flex",
  },
})
